import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const fetchProductOrderStatistics = async (productId, params = {}) => {
  const response = await axios.get(
    `${API_URL}/statistics/products/${encodeURIComponent(productId)}/orders`,
    { ...header(), params },
  );
  return response.data;
};

export default { fetchProductOrderStatistics };
